import { useMemo } from 'react';

import useUserRole from '@/hooks/domain/useUserRole';
import useKeymap from '@/hooks/pure/useKeymap';
import useDropdownStore from '@/stores/pure/DropdownStore';

import TagSelectModal from './TagSelectModal';

type Props = {
  selectedTags?: string[];
  toggleItem: (tag: string) => void;
  name: string;
  isCreate?: boolean;
  triggerEl?: HTMLDivElement | null;
};

const TagSelectorModal = (props: Props) => {
  const { currDropdown, setCurrDropdown, shortcutEnabled } = useDropdownStore(
    ({ currDropdown, setCurrDropdown, shortcutEnabled }) => ({
      currDropdown,
      setCurrDropdown,
      shortcutEnabled,
    }),
  );

  const { isEditor } = useUserRole();

  const toggleTagSelectModal = () => {
    if (!isEditor) return;
    setCurrDropdown(dropdownOpen ? null : props.name);
  };

  useKeymap('KeyT', () => {
    shortcutEnabled && toggleTagSelectModal();
  });

  const dropdownOpen = useMemo(() => {
    return currDropdown === props.name;
  }, [currDropdown, props.name]);

  return (
    <TagSelectModal
      selectedTags={props.selectedTags}
      toggleItem={props.toggleItem}
      closeModal={() => setCurrDropdown(null)}
      modalWidth="400px"
      status={dropdownOpen}
      triggerEl={props.triggerEl}
    />
  );
};

export default TagSelectorModal;
